import React from 'react';

import { Route, Routes } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';

import OrganizationMembershipCreatePage from './OrganizationMembershipCreatePage';
import OrganizationMembershipErrorPage from './OrganizationMembershipErrorPage';

const OrganizationMembership: React.FC = () => (
  <Routes>
    <Route path="new/*" element={<OrganizationMembershipCreatePage />} />
    <Route path="new/error" element={<OrganizationMembershipErrorPage />} />
    <Route path="*" element={<ErrorPage type="not_found" />} />
  </Routes>
);

export default OrganizationMembership;
